"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var icons_1 = require("@ant-design/icons");
var __1 = require("../..");
var transifex_1 = require("../../../transifex");
var ConfirmDeleteFile_1 = require("../ConfirmDeleteFile");
var imageTypes = ["image/jpeg", "image/jpg", "image/png"];
var UploadMultipleWithButton = function (_a) {
    var fileList = _a.fileList, onRemove = _a.onRemove, onChange = _a.onChange, style = _a.style, className = _a.className, disabled = _a.disabled, optionalMark = _a.optionalMark, _b = _a.showHeader, showHeader = _b === void 0 ? true : _b, _c = _a.showUploadButtonBottom, showUploadButtonBottom = _c === void 0 ? false : _c, _d = _a.confirmOnRemove, confirmOnRemove = _d === void 0 ? true : _d, _e = _a.showEmpty, showEmpty = _e === void 0 ? false : _e, props = __rest(_a, ["fileList", "onRemove", "onChange", "style", "className", "disabled", "optionalMark", "showHeader", "showUploadButtonBottom", "confirmOnRemove", "showEmpty"]);
    var imageFileList = fileList === null || fileList === void 0 ? void 0 : fileList.filter(function (file) { var _a; return imageTypes.includes((_a = file.type) !== null && _a !== void 0 ? _a : ""); });
    var otherFileList = fileList === null || fileList === void 0 ? void 0 : fileList.filter(function (file) { var _a; return !imageTypes.includes((_a = file.type) !== null && _a !== void 0 ? _a : ""); });
    // @ts-expect-error wip
    var confirmRemove = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!onRemove) return [3 /*break*/, 3];
                        if (!confirmOnRemove) return [3 /*break*/, 2];
                        return [4 /*yield*/, ConfirmDeleteFile_1.ConfirmDeleteFile()];
                    case 1:
                        if (_a.sent()) {
                            return [2 /*return*/, onRemove.apply(void 0, args)];
                        }
                        return [2 /*return*/, false];
                    case 2: return [2 /*return*/, onRemove.apply(void 0, args)];
                    case 3:
                        if (confirmOnRemove) {
                            return [2 /*return*/, ConfirmDeleteFile_1.ConfirmDeleteFile()];
                        }
                        return [2 /*return*/, true];
                }
            });
        });
    };
    var uplaodButton = (react_1.default.createElement(antd_1.Upload, __assign({ showUploadList: false, style: { width: "100%" }, accept: ".png,.jpg,.jpeg,.pdf,.docx,.doc", fileList: fileList, onRemove: confirmRemove, onChange: onChange, disabled: disabled }, props),
        react_1.default.createElement(antd_1.Button, { disabled: disabled, htmlType: "button", type: "ghost", icon: react_1.default.createElement(icons_1.UploadOutlined, { style: { marginRight: 10 } }) }, transifex_1.TX_UPLOAD)));
    return (react_1.default.createElement(antd_1.Row, { className: className, gutter: [0, 8], style: __assign({ width: "100%" }, style) },
        showHeader && (react_1.default.createElement(antd_1.Col, { xs: 24 },
            react_1.default.createElement(antd_1.Row, { style: { width: "100%" }, align: "middle", justify: "space-between" },
                react_1.default.createElement(antd_1.Col, null,
                    react_1.default.createElement(__1.Typography, null, transifex_1.TX_ATTACHMENTS),
                    optionalMark && (react_1.default.createElement(__1.Typography, { type: "secondary" },
                        " (",
                        transifex_1.TX_OPTIONAL,
                        ")"))),
                react_1.default.createElement(antd_1.Col, null, uplaodButton)))),
        react_1.default.createElement(antd_1.Col, { style: {
                display: (imageFileList === null || imageFileList === void 0 ? void 0 : imageFileList.length) === 0 ? "none" : "inline-block",
                // to prevent a ui bug where upload has a height with no data
            }, xs: 24 },
            react_1.default.createElement(antd_1.Upload, { onRemove: confirmRemove, onChange: function (_a) {
                    var _b;
                    var file = _a.file;
                    return onChange === null || onChange === void 0 ? void 0 : onChange({
                        file: file,
                        fileList: (_b = fileList === null || fileList === void 0 ? void 0 : fileList.filter(function (f) { return f.uid !== file.uid; })) !== null && _b !== void 0 ? _b : [],
                    });
                }, listType: "picture-card", fileList: imageFileList, disabled: disabled })),
        react_1.default.createElement(antd_1.Col, { style: {
                display: (otherFileList === null || otherFileList === void 0 ? void 0 : otherFileList.length) === 0 ? "none" : "inline-block",
            }, xs: 24 },
            react_1.default.createElement(antd_1.Upload, { onRemove: confirmRemove, onChange: function (_a) {
                    var _b;
                    var file = _a.file;
                    return onChange === null || onChange === void 0 ? void 0 : onChange({
                        file: file,
                        fileList: (_b = fileList === null || fileList === void 0 ? void 0 : fileList.filter(function (f) { return f.uid !== file.uid; })) !== null && _b !== void 0 ? _b : [],
                    });
                }, listType: "text", fileList: otherFileList, disabled: disabled })),
        showEmpty && !(fileList === null || fileList === void 0 ? void 0 : fileList.length) && (react_1.default.createElement(antd_1.Col, { xs: 24, style: { display: "flex", justifyContent: "center", padding: "1rem" } },
            react_1.default.createElement(antd_1.Empty, null))),
        showUploadButtonBottom && react_1.default.createElement(antd_1.Col, null, uplaodButton)));
};
exports.default = UploadMultipleWithButton;
